"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var BlogCitation_1 = require("../components/BlogModule/BlogCitation");
var targetNode = document.querySelector('.blog-citation');
if (targetNode) {
    (0, preact_1.render)((0, preact_1.h)(BlogCitation_1.default, null), targetNode);
}
